// src/shared/api/mutator.ts
import { axiosInstance } from './client';
import { registerInterceptors } from './interceptors';

// Install the axios interceptors. Idempotent — fetcher, mutator and upload
// each call it, and only the first one does the work.
registerInterceptors();

export interface MutatorConfig {
  headers?: Record<string, string>;
}

export default function mutator<T = unknown>(
  method: string,
  url: string,
  data?: unknown,
  config?: MutatorConfig,
): Promise<T> {
  return axiosInstance({ method, url, data, headers: config?.headers }).then((res) => res.data as T);
}
